import React from 'react';

export default function NavBar({ onNavigate, section }) {
  return (
    <nav className="navbar-fixed" style={{ padding: '1rem', background: '#222', color: '#fff' }}>

      <button 
        onClick={() => onNavigate(null)} 
        disabled={section===null}
        style={{ marginRight: '1rem', color: '#fff', background:'transparent', border:'none' }}
      >
        Home
      </button>

      <button 
        onClick={() => onNavigate('projects')} 
        disabled={section==='projects'}
        style={{ marginRight: '1rem', color: '#fff', background:'transparent', border:'none' }}
      >
        Projects
      </button>

      <button 
        onClick={() => onNavigate('cv')} 
        disabled={section==='cv'}
        style={{ color: '#fff', background:'transparent', border:'none' }}
      >
        CV
      </button>

      <button 
        onClick={() => onNavigate('contact')} 
        disabled={section==='contact'}
        style={{ color: '#fff', background:'transparent', border:'none' }}
      >
        Contact
      </button>
    </nav>
  );
}
